import { useCallback, useState } from 'react'
import clsx from 'clsx'

import { useModal } from '@/components/Modal'
import { Modal } from '@/ui/Modal'
import { Log } from '@/types/logs'
import { OfficialReportRequestBody, OfficialReportType } from '@/types/officialReport'
import styles from './OfficialReportModal.module.scss'
import { OfficialReportForm } from './OfficialReportForm'
import { OfficialReportReadOnly } from './OfficialReportReadOnly'

type Props = {
    type: OfficialReportType
    log: Log
    readOnly: boolean
    submitCallback?: (data: OfficialReportRequestBody) => void
    deleteCallback?: () => void
}

export const OfficialReportModal = () => {
    const { props, closeModal } = useModal<Props>()
    const [closeRequested, setCloseRequested] = useState(false)

    const handleClose = useCallback(() => {
        if (props?.readOnly) {
            closeModal()
        } else {
            setCloseRequested(true)
        }
    }, [closeModal, props?.readOnly])

    if (!props?.log) {
        return null
    }

    return (
        <Modal onClose={handleClose} className={clsx(styles.modal, { [styles.readOnlyModal]: props.readOnly })}>
            {props.readOnly && <OfficialReportReadOnly {...props} />}
            {!props.readOnly && (
                <OfficialReportForm
                    {...props}
                    closeRequested={closeRequested}
                    onCloseHandled={() => setCloseRequested(false)}
                />
            )}
        </Modal>
    )
}
